import { useState } from "react";
import Button from "@shared/v2/Button";
import { CheckSolidV6 } from "@shared/v2/Icomoon";

interface SaveProgressButtonProps {
  onClick: () => void | Promise<void>;
  disabled?: boolean;
  schema?: "primary" | "secondary";
  size?: "small" | "medium" | "large";
}

const SaveProgressButton = ({
  onClick,
  disabled = false,
  schema = "secondary",
  size = "medium",
}: SaveProgressButtonProps) => {
  const [state, setState] = useState<"idle" | "saving" | "success">("idle");

  const handleClick = async () => {
    setState("saving");

    try {
      await onClick();
    } catch {
      setState("idle");
      return;
    }

    setTimeout(() => {
      setState("success");
      setTimeout(() => {
        setState("idle");
      }, 1000);
    }, 1000);
  };

  return (
    // @ts-expect-error props
    <Button
      schema={schema}
      size={size}
      onClick={handleClick}
      isLoading={state === "saving"}
      disabled={disabled}
    >
      <span>
        {state === "success" ? "Saved " : "Save Progress"}
        {state === "success" && <CheckSolidV6 />}
      </span>
    </Button>
  );
};

export default SaveProgressButton;
